import { render, staticRenderFns } from "./AgencyOrders.vue?vue&type=template&id=4e84d898&"
import script from "./AgencyOrders.vue?vue&type=script&lang=js&"
export * from "./AgencyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports